export enum DocumentEvent {
  UPLOAD = 'upload',
  FAILED_UPLOAD = 'failed_upload',
  CHECKBOT_INPUT_LIST_ENTRY = 'checkbot_input_list_entry',
  CHECKBOT_INPUT_FAILED = 'checkbot_input_failed',
  METADATA_INFERENCE_CHECKBOT_INPUT_LIST_ENTRY = 'metadata_inference_checkbot_input_list_entry',
  CHECKBOT_RESULT = 'checkbot_result',
  METADATA_INFERENCE_CHECKBOT_RESULT = 'metadata-inference-checkbot-result',
  METADATA_CHECK_RESULT = 'metadata_check_result',
  REVERTED_TO_METADATA_CHECK = 'reverted_to_metadata_check',
  QUALITY_CHECK = 'quality_check',
  NEW_RESULTS_INSPECTOR_NOTIFICATION = 'new_results_inspector_notification',
  FAILED_CHECK_SUPPLIER_NOTIFICATION = 'failed_check_supplier_notification',
  FAILED_INSPECTION_SUPPLIER_NOTIFICATION = 'failed_inspection_supplier_notification',
  INSPECTION_DUE_INSPECTORS_NOTIFICATION = 'inspection_due_inspectors_notification',
  INSPECTION = 'inspection',
  COPIED_TO_RECORD_LIBRARY = 'copied_to_record_library',
  RENDITION_FILE_COPIED_TO_RECORD_LIBRARY = 'rendition_file_copied_to_record_library',
  DOCUMENT_UPDATED = 'document_updated',
  DUPLICATE_DETECTED = 'duplicate_detected',
}
